import { useHistory, useLocation } from "react-router-dom";
import { additionalPurchase, reinitate } from "../../../store/actions";
import { useDispatch } from "react-redux";
import { DetailsGroup } from "../transactions/newPurchaseConfirm";
import { useState, useEffect } from "react";
import { CartItemsMap } from "../../../store/types";
import { CustomizedDialogsforReintitate } from "../customModal";
import { handleError } from "../../../utils/cart";

interface LocationState {
  fundCode: string;
  ihno: string;
}

export default function AdditionalPurchase() {
  const { state } = useLocation<LocationState>();

  const history = useHistory();
  const dispatch = useDispatch();

  const { ihno } = state;

  // @ts-ignore
  const [payload, setPayload] = useState<CartItemsMap["APL"]>({});
  const [isOpen, setIsOpen] = useState(false);
  const [referenceNumber, setReferenctNumber] = useState("");

  useEffect(() => {
    (async function () {
      try {
        const response = await reinitate<"APL">(ihno)(dispatch);
        setPayload(response);
      } catch (error) {
        alert(error);
      }
    })();
  }, [dispatch, ihno]);

  function goToDashboard() {
    history.push("/dashboard");
  }

  async function onConfirm() {
    try {
      history.replace("/payment-options/additional-purchase/single", {
        requestBody: payload,
      });
    } catch (error) {
      handleError(error);
    }
  }

  return (
    <div
      className="table_border"
      style={{
        margin: "32px 48px",
      }}
    >
      <div
        className="container-fluid d-flex flex-column shadow-sm bg-white rounded"
        style={{
          minHeight: "240px",
          padding: "24px 36px",
        }}
      >
        <div className="d-flex justify-content-between align-items-center">
          <p className="text-primary mb-0" style={{ fontSize: 14 }}>
            Confirm re-initiation of Additional Purchase transaction
          </p>
        </div>
        <DetailsGroup
          mainLabel={"Investor Name"}
          subLabel={payload.investorName}
          mainLabel1={"Investor Pan"}
          subLabel2={payload.pan}
        />
        <DetailsGroup
          mainLabel={"Email"}
          subLabel={payload.email}
          mainLabel1={"Mobile"}
          subLabel2={payload.mobile}
        />
        <DetailsGroup
          mainLabel={"Scheme"}
          subLabel={payload.schemeName}
          mainLabel1={"Folio"}
          subLabel2={payload.folio}
        />
        <DetailsGroup mainLabel="Amount" subLabel={payload.amount} />
        <DetailsGroup mainLabel={"Arn Code"} subLabel={payload.arnCode} />
      </div>
      <div
        className="d-flex justify-content-center mt-4 mb-6 MuiTableCell-root table-cell"
        style={{ border: "none", padding: "4px" }}
        onClick={onConfirm}
      >
        <div className="transaction-button mouse-pointer text-uppercase d-flex align-items-center">
          Confirm
        </div>
      </div>
      <CustomizedDialogsforReintitate
        open={isOpen}
        closeModal={goToDashboard}
        componentName={"Additional Purchase"}
        refNo={referenceNumber}
        confirmation={goToDashboard}
      />
    </div>
  );
}
